export const CHAT_TITLE_DEFAULT = "New chat"
export const CHAT_PROMPT_MAX_LENGTH = 20000